import { ResponseAction } from "@alme/types/response/ResponseAction";

import { AlmeResponseNext } from '@alme/types/response/AlmeResponse';
import { AlmeAppState } from "../../AlmeApp/AlmeAppState";

export interface LiveChatStartAction extends ResponseAction {
    Name: "LiveChatStart";
}

export function processLiveChatStartAction(response: AlmeResponseNext, almeState: AlmeAppState, setAlmeState: (almeState: AlmeAppState) => void): void {
    if (!almeState.isLiveChatConnected && response?.responseActions) {
        for (const action of response.responseActions) {
            if (action.Name === "LiveChatStart") {
                setAlmeState({
                    ...almeState,
                    isLiveChatConnected: true,
                } as AlmeAppState);
                return;
            }
        }
    }
}
